<template>
    <!--手机端注册-->
    <!--导航栏-->
    <ZhaiHead></ZhaiHead>
    <!--导航栏-->
    <!--只是占据空间-->
    <div class="gongxi1"></div>
    <!--顶部占据空间-->
    <!--主体内容-->
    <div class="container-fluid shengse">
        <div class="row mt-2">
            <div class="dixian px-4 py-2 d-flex justify-content-between">
                <div><i class="bi bi-person-add"></i>用户注册</div>
            </div>
        </div>
        <div class="px-4 zhai-s">
            <div class="mb-3">
                <input type="text" class="form-control custom-input" id="username" v-model="myform.username" placeholder="请输入用户名" :class="{ 'is-invalid': errors.username }">
            </div>
            <div class="mb-3">
                <input type="password" class="form-control custom-input" id="password" v-model="myform.password" placeholder="请输入密码" :class="{ 'is-invalid': errors.password }">
            </div>
            <div class="mb-3">
                <input type="password" class="form-control custom-input" id="password2" v-model="myform.password2" placeholder="请再次输入密码" :class="{ 'is-invalid': errors.password2 }">
            </div>
            <div class="mb-3">
                <input type="email" class="form-control custom-input" id="email" v-model="myform.email" placeholder="邮箱" :class="{ 'is-invalid': errors.email }">
            </div>

            <!-- 验证码组件 -->
            <CaptchaComponent @validate-captcha="validateCaptcha" ref="captchaComponent"></CaptchaComponent>

            <div class="col-12 mt-4 text-center">
                <button type="button" @click="reg()" class="btn btn-success w-100 z-f-sm">注册</button>
            </div>

            <div class="zhan"></div>
        </div>
    </div>
    <!--主体内容-->

    <!--只是占据空间-->
    <div class="gongxi2"></div>
    <!--顶部占据空间-->

    <!--公共底部-->
    <ZhaiFoot></ZhaiFoot>
    <!--公共底部-->
    <div class="modal fade" id="errorModal" tabindex="-1" aria-labelledby="errorModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered small-modal">
            <div class="modal-content">
                <div class="modal-body d-flex align-items-center justify-content-center small-padding">
                    <i class="bi bi-emoji-frown small-icon"></i>
                    <p class="mb-0 ms-2 small-text">{{ errorMessage }}</p>
                </div>
            </div>
        </div>
    </div>
    <!-- 成功模态框 -->
    <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered small-modal">
            <div class="modal-content">
                <div class="modal-body d-flex align-items-center justify-content-center small-padding">
                    <i class="bi bi-emoji-smile small-icon" style="color: #00c26f;"></i>
                    <p class="mb-0 ms-2 small-text" style="color: #00c26f;">注册成功</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import http from "../utils/http.js";
    import ZhaiHead from "../components/ZhaiHead";
    import ZhaiFoot from "../components/ZhaiFoot";
    import CaptchaComponent from "../componentspc/CaptchaComponent.vue";
    import { Modal } from "bootstrap";

    export default {
        name: "MRegister",
        components: { ZhaiHead, ZhaiFoot, CaptchaComponent },

        data() {
            return {
                myform: {
                    username: "",
                    password: "",
                    password2: "",
                    email: ""
                },
                errors: {},
                errorMessage: "",
                captchaValid: false,

                // ✅ 只用 iuid
                iuid: null
            };
        },

        methods: {
            /* =========================
               1️⃣ iuid 工具（只认 iuid）
            ========================== */

            // 从当前 URL 获取 iuid
            getIuidFromUrl() {
                const params = new URLSearchParams(window.location.search);
                return (params.get("iuid") || "").trim();
            },

            // iuid 必须是 5 位数字
            isValidIuid(iuid) {
                return /^\d{5}$/.test(String(iuid || "").trim());
            },

            // 保存 iuid（默认 7 天）
            saveIuid(iuid) {
                const expireTime = Date.now() + 7 * 24 * 60 * 60 * 1000;
                const data = { iuid: String(iuid).trim(), expire: expireTime };
                localStorage.setItem("inviteData", JSON.stringify(data));
            },

            // 读取缓存 iuid（自动处理过期/脏数据）
            getSavedIuid() {
                const raw = localStorage.getItem("inviteData");
                if (!raw) return null;

                try {
                    const data = JSON.parse(raw);
                    if (!data || !data.iuid || !data.expire) {
                        localStorage.removeItem("inviteData");
                        return null;
                    }

                    const iuid = String(data.iuid).trim();
                    const expire = Number(data.expire);

                    if (!this.isValidIuid(iuid) || !expire || Date.now() > expire) {
                        localStorage.removeItem("inviteData");
                        return null;
                    }

                    return iuid;
                } catch (e) {
                    localStorage.removeItem("inviteData");
                    return null;
                }
            },

            // 最终可用 iuid：URL 优先，其次缓存
            resolveIuid() {
                const fromUrl = this.getIuidFromUrl();
                if (this.isValidIuid(fromUrl)) return fromUrl;

                const fromCache = this.getSavedIuid();
                if (this.isValidIuid(fromCache)) return fromCache;

                return null;
            },

            /* =========================
               2️⃣ 验证码
            ========================== */
            validateCaptcha(isValid) {
                this.captchaValid = isValid;
                this.$refs.captchaComponent.captchaError = !isValid;
            },

            /* =========================
               3️⃣ 注册逻辑
            ========================== */
            reg() {
                this.errors = {};

                if (!this.myform.username.trim()) {
                    this.showErrorModal("用户名不能为空", "username");
                    return;
                }

                if (
                    this.myform.username.length < 4 ||
                    this.myform.username.length > 20 ||
                    this.myform.username.includes(" ")
                ) {
                    this.showErrorModal("用户名必须介于4-20个字符且不能包含空格", "username");
                    return;
                }

                if (!this.myform.password.trim()) {
                    this.showErrorModal("密码不能为空", "password");
                    return;
                }

                if (!/^[^\s]{6,15}$/.test(this.myform.password)) {
                    this.showErrorModal("密码应为6-15位字符且不能包含空格", "password");
                    return;
                }

                if (this.myform.password !== this.myform.password2) {
                    this.showErrorModal("两次密码不一致", "password2");
                    return;
                }

                if (!this.myform.email.trim()) {
                    this.showErrorModal("邮箱不能为空", "email");
                    return;
                }

                if (!this.validateEmail(this.myform.email)) {
                    this.showErrorModal("邮箱格式有误", "email");
                    return;
                }

                if (!this.$refs.captchaComponent.enteredCaptcha.trim()) {
                    this.showErrorModal("验证码不能为空", "captcha");
                    this.$refs.captchaComponent.captchaError = true;
                    return;
                }

                this.validateCaptcha(
                    this.$refs.captchaComponent.enteredCaptcha.trim() ===
                    this.$refs.captchaComponent.captchaText
                );

                if (!this.captchaValid) {
                    this.showErrorModal("图形验证码输入不正确！", "captcha");
                    return;
                }

                const url = "/platform/frontEnd/register";
                const fm = new FormData();

                fm.append("username", this.myform.username);
                fm.append("password", this.myform.password);
                fm.append("password2", this.myform.password2);
                fm.append("email", this.myform.email);

                // ✅ 核心：注册时永远尽力带上 iuid（URL 或缓存）
                const iuid = this.resolveIuid();
                this.iuid = iuid;

                if (this.isValidIuid(iuid)) {
                    fm.append("iuid", iuid);
                    console.log("注册携带 iuid:", iuid);
                } else {
                    console.log("注册未携带 iuid（URL与缓存均无有效值）");
                }

                http
                    .post(url, fm, true)
                    .then((data) => {
                        if (data.data.status === 1) {
                            this.autoLogin();
                        } else {
                            this.handleFormErrors(data.data);
                        }
                    })
                    .catch((error) => {
                        console.error("注册请求失败:", error);
                        this.showErrorModal("注册请求失败，请稍后重试。");
                    });
            },

            /* =========================
               4️⃣ 自动登录
            ========================== */
            autoLogin() {
                const url = "/platform/frontEnd/login";
                const fm = new FormData();

                fm.append("username", this.myform.username);
                fm.append("password", this.myform.password);

                http
                    .post(url, fm, { untoken: true })
                    .then((response) => {
                        if (response.data.status === 1 && response.data.data) {
                            const data = response.data.data;

                            const userData = {
                                user: {
                                    id: data.id,
                                    username: data.username,
                                    email: data.email,
                                    level: data.level,
                                    level_expire_date: data.level_expire_date
                                },
                                token: data.token
                            };

                            if (!userData.user || !userData.token) {
                                this.showErrorModal("登录失败，用户或令牌无效");
                                return;
                            }

                            this.$store.dispatch("login", userData);
                            localStorage.setItem("authToken", userData.token);
                            localStorage.setItem("user", JSON.stringify(userData.user));

                            // ✅ 注册成功后清除 iuid 缓存（避免误归因）
                            localStorage.removeItem("inviteData");

                            this.showSuccessModal();
                        } else {
                            this.showErrorModal(response.data.msg || "登录失败！");
                        }
                    })
                    .catch(() => {
                        this.showErrorModal("请求失败，请稍后重试。");
                    });
            },

            /* =========================
               5️⃣ UI & 工具
            ========================== */
            showSuccessModal() {
                const modalElement = document.getElementById("successModal");
                const modal = new Modal(modalElement);
                modal.show();

                setTimeout(() => {
                    modal.hide();
                    this.$router.push("/memberCenter");
                }, 3000);
            },

            validateEmail(email) {
                const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return re.test(email);
            },

            handleFormErrors(data) {
                if (data.field && data.message) {
                    this.showErrorModal(data.message, data.field);
                } else {
                    this.showErrorModal(data.msg || "注册失败！");
                }
            },

            showErrorModal(message, field) {
                this.errorMessage = message;

                if (field) {
                    this.errors[field] = true;
                }

                const modalElement = document.getElementById("errorModal");
                const modal = new Modal(modalElement);
                modal.show();

                setTimeout(() => {
                    modal.hide();
                }, 3000);
            }
        },

        mounted() {
            this.$refs.captchaComponent.generateCaptcha();

            // ✅ 进入注册页时捕获一次 iuid（只认 iuid）
            const fromUrl = this.getIuidFromUrl();
            if (this.isValidIuid(fromUrl)) {
                this.saveIuid(fromUrl);
                console.log("注册页捕获 iuid:", fromUrl);
            }

            // ✅ 初始化当前可用 iuid（供 reg() 使用/日志）
            this.iuid = this.resolveIuid();
            console.log("注册页最终可用 iuid:", this.iuid);
        }
    };
</script>


<style scoped>
    /*主体与顶端的内边距*/
    .zhai-s {
        padding-top: 10px;
    }

    /*横线的元素*/
    hr {
        border: none; /* 移除默认的边框 */
        height: 1px; /* 设置横线的高度 */
        background-color: #333; /* 设置横线的颜色 */
        margin-top: 10px !important;
    }
    /* 自定义输入框样式 */
    .custom-input {
        border-radius: 2px !important;
        line-height: 1.5 !important;
    }

    /*提示文字红色*/
    .tishi {
        color: red;
        font-size: 0.9rem;
    }

    /*恭喜发财的样式*/
    .facai {
        font-size: 20px;
        color: lightslategrey;
        text-align: center;
        margin-top: 85px;
        margin-bottom: 10px;
    }

    /*随机生成文字框的样式*/
    .br5 {
        border-radius: 5px;
        border: 1px solid #f2f2f2;
    }
    .gongxi1 {
        height: 70px;
    }
    /*底部不占据空间*/
    .gongxi2 {
        height: 20px;
    }

    .zhan {
        height: 30px;
    }

    /*按钮颜色字体大小*/
    .btn-success {
        background-color: #00c26f !important;
        font-size: 0.9rem;
        border: none !important;
    }

    /*输入框内和提示文字的大小*/
    .form-control {
        font-size: 0.9rem;
    }

    /* 调整验证码图片与输入框对齐 */
    .d-flex.align-items-center {
        display: flex;
        align-items: center;
    }

    .ml-3 {
        margin-left: 1rem;
    }

    /* 错误输入框样式 */
    .is-invalid {
        border-color: #dc3545 !important;
        background-image: none !important; /* 移除叹号图标 */
    }

    /* 添加模态框抖动效果 */
    @keyframes shake {
        0%, 100% { transform: translateX(0); }
        10%, 30%, 50%, 70%, 90% { transform: translateX(-2px); }
        20%, 40%, 60%, 80% { transform: translateX(2px); }
    }
    .modal-content.shake {
        animation: shake 0.5s;
    }

    /* 调整模态框和文本的大小 */
    .small-modal .modal-content {
        width: 100%;
        max-width: 250px;
        margin: 0 auto;
    }
    .small-padding {
        padding: 0px !important;
    }
    .small-icon {
        font-size: 1.5rem;
        color: #dc3545;
    }
    .small-text {
        font-size: 0.9rem;
        color: #dc3545;
    }
</style>
